import { durationToUnit } from '@cast/utils';

import { DataGranularity } from 'types/cost-report';

export const granularityToSeconds = (granularity: DataGranularity): number =>
  durationToUnit(`${granularity.step}${granularity.unit}`, 'seconds');
